import { render } from "./ProfileUser.vue?vue&type=template&id=03122c28"
import script from "./ProfileUser.vue?vue&type=script&lang=ts"
export * from "./ProfileUser.vue?vue&type=script&lang=ts"

import "./ProfileUser.vue?vue&type=style&index=0&id=03122c28&lang=scss"
script.render = render

export default script